import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {StepperContainerComponent} from '../shared/stepper/stepper-container/stepper-container.component';
import {ActivatedRoute, Params} from '@angular/router';

@Component({
  selector: 'app-ocas-stepper',
  templateUrl: './ocas-stepper.component.html',
  styleUrls: ['./ocas-stepper.component.scss']
})
export class OcasStepperComponent implements OnInit {

  carriercode:any;
  carrierId:any;
  @ViewChild(StepperContainerComponent) StepperContainer;
  constructor(private activeRoute: ActivatedRoute,) {
    this.activeRoute.params.subscribe((params: Params) => {
      this.carriercode = params["carriercode"];
      this.carrierId = params["id"];
    });
  }
  @Input() isQuestionnaireInProgress: string = 'true';
  @Input() isDepotsInProgress: string = 'true';
  @Input() isDriverInProgress: string = 'true';
  @Input() isVehiclesInProgress: string = 'true';
  ngOnInit(): void {
  }


  goNext(){
    this.StepperContainer.activeStepper.isProgress = 'false';
    this.StepperContainer.next();
  }
  prevStep(){
    this.StepperContainer.previous();
  }
}
